import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setAttempts,
  setDateTime,
  setSuccessfulAttempt,
  setAirTemperatureUnit,
  setAction,
  saveAirway,
} from '../../procedures/airway/store/airway.actions'
import { setAddAirwayToTimeline } from '../store/quickActions.actions'
import { IAirwayOptionsState, IVitalOptionsState } from '../../options/store/options.types'
import { getAirwayOptionsSelector, getVitalOptionsSelector } from '../../options/selectors'
import { getDefaultTempTypeSelector } from '../../configurations/selectors/defaultTempType.selector'
import { IOption } from '../../../common/common.types'

export function* setAirwayQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const defaultTempType: string | null = yield select(getDefaultTempTypeSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate, procedureAction } = props
  const airwayOptions: IAirwayOptionsState = yield select(getAirwayOptionsSelector)
  const { actionOptions } = airwayOptions

  const actionOption = actionOptions.find((option: IOption) => option.id === procedureAction)
  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setAction(actionOption ? actionOption : null))
  if (defaultTempType && defaultTempType === 'c') {
    yield put(setAirTemperatureUnit(false))
    yield put(saveAirway())
  } else {
    yield put(setAirTemperatureUnit(true))
    yield put(saveAirway())
  }
  yield put(setAddAirwayToTimeline(true))
}

export function* setAirwayQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_AIRWAY_BUTTON_TYPE], setAirwayQuickAction)
}
